// extracted by mini-css-extract-plugin
export var equalColumn = "_il-0";